import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/contracts/templates')({
  component: Outlet,
  head: () => ({ meta: [{ title: '合同模板 · Super Mega' }] })
})
